import { UPDATE_BREADCRUMB } from '#action/types';

export default function (state = [], action) {
  switch (action.type) {
    case UPDATE_BREADCRUMB:
      return [...action.payload];
    default:
      return state;
  }
}
